module.exports = __webpack_public_path__ + "media/images/emblems/Vandoeuvres-coat_of_arms-f9648c4b2807c7414cad0e3fde555052.svg";